export default __webpack_public_path__ + "static/media/1_2.0ef4f1f3.jpg";